import { render, staticRenderFns } from "./DownloadV3.vue?vue&type=template&id=0dcd90ce"
import script from "./DownloadV3.vue?vue&type=script&lang=js"
export * from "./DownloadV3.vue?vue&type=script&lang=js"
import style0 from "./DownloadV3.vue?vue&type=style&index=0&id=0dcd90ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports